<template>
    <div v-loading="dataLoading">
        <el-form :model="formData" :rules="rules" ref="formData" label-position="top" size="medium">
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="cover" label="合约封面：">
                        <ImageUpload :url.sync="formData.cover" :urlFull.sync="coverUrl" :disabled="disabled"></ImageUpload>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="videoUrl" label="合约视频：">
                        <VideoUpload :url.sync="formData.videoUrl" :urlFull.sync="videoUrl"
                            :cover.sync="coverUrl" @onSuccess="$refs.formData.clearValidate('videoUrl')" :disabled="disabled">
                        </VideoUpload>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="name" label="合约名称：">
                        <el-input v-model="formData.name" :maxlength="20" show-word-limit :disabled="disabled"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="authorObj" label="作者:">
                        <el-select v-model="formData.authorObj" filterable remote placeholder="请输入用户名"
                            :remote-method="searchUser" :loading="userLoading" value-key="id" :disabled="disabled">
                            <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="goodsId" label="关联周边：">
                        <el-input v-model="formData.goodsId" :maxlength="10"></el-input>
                    </el-form-item>
                    <!-- <el-form-item prop="datetimerange" label="发售时间：">
                        <el-date-picker v-model="formData.datetimerange" type="datetimerange" start-placeholder="开始时间"
                            end-placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']" unlink-panels :disabled="disabled"></el-date-picker>
                    </el-form-item> -->
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="isSupportTransfer" label="是否支持转赠：">
                        <el-select v-model="formData.isSupportTransfer" :disabled="disabled">
                            <el-option label="支持转赠" :value="1"></el-option>
                            <el-option label="不支持转赠" :value="0"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row v-if="formData.isSupportTransfer == 1" :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="transferStartTime" label="转赠开始时间：">
                        <el-date-picker v-model="formData.transferStartTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                            default-time="00:00:00" :disabled="disabled"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="transferEndTime" label="转赠结束时间：">
                        <el-date-picker v-model="formData.transferEndTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                            default-time="23:59:59" :disabled="disabled"></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="30">
                <el-col :xs="24" :xl="16">
                    <el-form-item prop="rights" label="合约权益：">
                        <span slot="label">合约权益：<el-button v-if="formData.rights.length < 20" icon="el-icon-plus" size="mini" type="primary" plain @click="$refs.rightsEdit.show()" :disabled="disabled">新增权益</el-button></span>
                        <el-table :data="formData.rights && formData.rights.filter(v => v.status == 1)" border style="width: 100%" size="mini" stripe class="sortable-table" row-key="sort">
                            <el-table-column prop="name" label="名称" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="description" label="描述" show-overflow-tooltip></el-table-column>
                            <el-table-column label="有效期" min-width="150">
                                <template slot-scope="scope">
                                    {{scope.row.validStartTime ? `起：${scope.row.validStartTime}` : ''}}
                                    <p>止：{{scope.row.validEndTime ? `${scope.row.validEndTime}` : '兑换前长期有效'}}</p>
                                </template>
                            </el-table-column>
                            <el-table-column label="是否分配编号">
                                <template slot-scope="scope">{{scope.row.maxNum == 0 ? '不分配' : "分配"}}</template>
                            </el-table-column>
                            <el-table-column prop="maxNum" label="号段最大值"></el-table-column>
                            <el-table-column prop="maxDigit" label="编号显示位数"></el-table-column>
                            <el-table-column prop="excludeNum" label="预留编号" show-overflow-tooltip></el-table-column>
                            <!-- <el-table-column prop="status" label="禁用状态">
                                <template slot-scope="scope">
                                    <el-tag v-if="scope.row.status == 1" size="mini">开启</el-tag>
                                    <el-tag v-else type="info" size="mini">禁用</el-tag>
                                </template>
                            </el-table-column> -->
                            <el-table-column fixed="right" label="操作" width="100">
                                <template slot-scope="scope">
                                    <el-button
                                        type="text"
                                        size="small"
                                        @click="$refs.rightsEdit.show(scope.row)"
                                        >编辑</el-button
                                    >
                                    <el-button
                                        v-if="scope.row.status == 1"
                                        type="text"
                                        size="small"
                                        @click="rightsDel(scope.row,scope.$index)"
                                        :disabled="disabled"
                                        >删除</el-button
                                    >
                                </template>
                            </el-table-column>
                        </el-table>
                        <div v-if="formData.rights.length > 1" class="form-tips color-info"><i class="el-icon-warning"></i> 可拖动排序</div>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div class="page-btns-box MT20">
            <el-button @click="goBack">返 回</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading">确 定</el-button>
        </div>

        <rights-edit ref="rightsEdit" @onUpdate="rightsUpdate" :disabled="disabled"></rights-edit>
    </div>
</template>
<script>
import { fetchUser } from '@/assets/js/commonApi';
import ImageUpload from "@/components/ImageUpload";
import VideoUpload from "@/components/VideoUpload";
import RightsEdit from "./components/RightsEdit";
import Sortable from "sortablejs";

const defaultFormData = {
    authorId:"",	//作者id
    authorName:"",	//	作者名称
    // chainClassId:"",	//	联盟链合约地址
    cover:"",	//	封面图地址
    goodsId:"",	//	商品id
    // goodsName:"",	//商品名称
    id:"",	//	id
    // isLinked:1,	//	是否上链 1：是 0：否
    isSupportTransfer: 0,	//	是否支持转赠 1：支持 0：不支持	
    name:"",	//	合约名称
    priceFormat:0,	//价格格式化
    saleEndTime:"",	//	发售结束时间
    saleStartTime:"",	//	发售开始时间
    videoUrl:"",	//	视频地址
    rights: [], //权益

    datetimerange: null, //时间区间
    authorObj: null, // 作者
    transferStartTime: '', //转赠开始时间
    transferEndTime: '' //转赠结束时间
}
export default {
    props: {
        id: {
            type: [String, Number],
            default: ""
        }
    },
    components: { ImageUpload, VideoUpload,RightsEdit},
    data(){
        const rightsCheck = (rule, value, callback) =>{
            let flag = value && value.filter(v => v.status == 1);
            
            if(flag.length < 1){
                callback(new Error('请添加权益!'));
            }else{
                callback();
            }
        }
        return{
            formData: {
                ...defaultFormData,
                rights: [], //权益
            },
            rules:{
                cover: [{ required: true, message: "请上传合约封面" }],
                // videoUrl: [{ required: true, message: "请上传合约视频" }],
                name: [{ required: true, message: "请填写合约名称" }],
                authorObj: [{ required: true, message: "请选择作者" }],
                goodsId: [{ pattern: /^[0-9]+$/, message: "请输入正确的ID" }],
                rights: [{ validator: rightsCheck }],
            },
            dataLoading: false,
            btnLoading: false,
            redirect: this.$route.query.redirect || '/nftManage/contract/list',
            
            userLoading: false,
            userList: [],

            videoUrl: "",
            coverUrl: "",
            disabled: false
        }
    },
    mounted() {
        if (this.id) {
            this.getDetailData();
        }
    },
    methods:{
        //获取详情
        getDetailData() {
            this.dataLoading = true;
            this.$request({
                url: "/contract/detail",
                method: "POST",
                params: {
                    id: this.id
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.formData = {
                            ...defaultFormData,
                            ...result,
                            datetimerange: result.saleStartTime ? [result.saleStartTime, result.saleEndTime] : [],
                            authorObj: {
                                id: result.authorId || '',
                                name: result.authorName || ''
                            }
                        };

                        if(result.authorId){
                            this.userList = [{
                                id: result.authorId,
                                name: result.authorName
                            }]
                        }

                        this.coverUrl = result.cover;
                        this.videoUrl = result.videoUrl;
                        this.disabled = result.isLinked == 1 ? true : false

                        this.rightsUpdate();
                        this.drag();

                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        // 搜索用户
        searchUser(query) {
            this.gethUser(query, -1, "userList");
        },
        async gethUser(query, userType, obj) {
            if (query !== "") {
                this.userLoading = true;
                const res = await fetchUser({
                    queryValue: query,
                    userType: userType,
                }).finally(() => {
                    this.userLoading = false;
                });

                const { state, result } = res.data;

                if (state == 1 && result) {
                    this[obj] = result;
                }
            }
        },
        //表单提交
        submitForm() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    if( this.$utils.compareDate(this.formData.transferStartTime, this.formData.transferEndTime) ){
                        return this.$message.error("转赠开始时间不能大于等于结束时间");
                    }
                    this.btnLoading = true;
                    this.$request({
                        url: '/contract/save',
                        method: "post",
                        data: {
                            ...this.formData,
                            saleStartTime: this.formData.datetimerange ? this.formData.datetimerange[0] : '',
                            saleEndTime: this.formData.datetimerange ? this.formData.datetimerange[1] : '',
                            authorId: this.formData.authorObj ? this.formData.authorObj.id : "",	//作者id
                            authorName: this.formData.authorObj ? this.formData.authorObj.name : "",	//作者名称
                        },
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.goBack();
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            this.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                } else {
                    return false;
                }
            });
        },
        //返回
        goBack() {
            if (this.redirect) {
                this.$router.push({
                    path: this.redirect,
                });
            } else {
                this.$router.go(-1);
            }
        },

        //权益更新
        rightsUpdate(data){
            if(data){
                if(data.sort === undefined){
                    this.formData.rights.push(data);
                }else{
                    this.$set(this.formData.rights,data.sort-1,data);
                }
                this.$refs.formData.clearValidate('rights');
                this.drag();
            }
            this.formData.rights.map((v,i) => {
                if( v.status == 1 ){
                    this.$set(this.formData.rights[i],"sort",i + 1);
                }else{
                    this.$set(this.formData.rights[i],"sort", 9999);
                }
                // v.sort = i + 1;
            })
            this.formData.rights.sort((a,b) => {
                if(a.sort > b.sort){
                    return 1;
                }else{
                    return -1;
                }
            })

        },
        //拖拽排序
        drag(){
            this.$nextTick(() => {
                const el = document.querySelectorAll('.sortable-table > .el-table__body-wrapper > table > tbody')[0];
                    Sortable.create(el, {
                        disabled: false, // 拖拽不可用? false 启用
                        ghostClass: 'sortable-ghost', //拖拽样式
                        animation: 150, // 拖拽延时，效果更好看
                        onEnd: (e) => { // 拖拽结束时的触发
                            let arr = [...this.formData.rights]; // 获取表数据
                            arr.splice(e.newIndex, 0, arr.splice(e.oldIndex, 1)[0]); // 数据处理，获取最新的表格数据
                            this.formData.rights = arr;
                            this.$nextTick( () => {
                                // const a1 = (this.formData.rights.map(a => a.id)).toString();
                                // const a2 = (arr.map(a => a.id)).toString();
                                // if(a1 != a2){
                                    
                                    this.rightsUpdate();
                                    // console.log(this.formData.rights);
                                // }
                            })
                        },
                    });
            })
        },
        //删除权益
        rightsDel(data,index){
            this.$confirm('删除后不可恢复，确定要删除吗？', '提示', {
                // type: 'warning',
                center: true,
                closeOnClickModal: false,
                dangerouslyUseHTMLString: true,
            }).then(() => {
                if( data.id ){
                    this.formData.rights[index].status = 0;
                }else{
                    const _arr = this.formData.rights.filter(v => v.status == 1);
                    this.formData.rights = _arr.filter((v,i) => i !== index);
                }
                this.rightsUpdate();
            }).catch(() => {});
        }
    }
}
</script>
<style lang="scss" scoped>

</style>